// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"56728320","64":"4fbd53af","223":"7a348287","308":"c33be2b2","446":"630d2e86","593":"79a85e43"}[chunkId] + ".chunk.js";
};